import React from 'react';
import { Link } from 'react-router-dom';

const MediaGallery: React.FC = () => {
  return (
    <div className="media-gallery-page">
      {/* Page Header */}
      <div className="relative bg-primary py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-4 animate-fadeInDown">Media Gallery</h1>
          <nav className="flex justify-center animate-fadeInUp">
            <ol className="flex items-center space-x-2 text-white">
              <li><Link to="/" className="hover:text-secondary">Home</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li><Link to="/about" className="hover:text-secondary">About</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li className="text-secondary">Media Gallery</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Gallery Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 animate-fadeInUp">
            <h2 className="text-4xl font-bold mb-4">Our Gallery</h2>
            <p className="text-gray-600 text-lg">
              Explore our collection of images and videos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
              <div 
                key={item} 
                className="group relative overflow-hidden rounded-lg shadow-lg animate-fadeInUp cursor-pointer"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <img 
                  src={`/img/gallery-${item}.jpg`}
                  alt={`Gallery ${item}`}
                  className="w-full h-64 object-cover transform group-hover:scale-110 transition duration-500"
                />
                <div className="absolute inset-0 bg-primary bg-opacity-0 group-hover:bg-opacity-80 transition duration-300 flex items-center justify-center">
                  <i className="fas fa-search-plus text-white text-3xl opacity-0 group-hover:opacity-100 transition duration-300"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default MediaGallery;